import { DecisionTypeHandler } from "@/dbot/common/commonDomain";
import {
  ApproveAuditorRemuneration,
  ApproveAuditorRemunerationForm,
} from "./approveAuditorRemunerationDomain";
import { DecisionType } from "@/common/decisions";

export const approveAuditorRemunerationHandler: DecisionTypeHandler<
  DecisionType.approveAuditorRemuneration,
  ApproveAuditorRemuneration,
  ApproveAuditorRemunerationForm
> = {
  type: DecisionType.approveAuditorRemuneration,

  initNewForm(_dispatch, context, data) {
    return new ApproveAuditorRemunerationForm(context, data);
  },

  validate(form) {
    return form.validate();
  },

  isValid(form) {
    return form.isValid;
  },

  applyForm(form): ApproveAuditorRemuneration {
    return {
      type: DecisionType.approveAuditorRemuneration,
      isCoveredByInvoice: form.isCoveredByInvoice.value,
      specifiedValue: form.specifiedValue.toNumber(),
      period: form.period.toISOString(),
      isDeviatingPeriod: form.isDeviatingPeriod.value,
      deviatingPeriodFrom: form.deviatingPeriodFrom.toISOString(),
      deviatingPeriodTo: form.deviatingPeriodTo.toISOString(),
    };
  },
};
